export enum CountPickerStyle {
  learningIntervalUnitCount,
  learningGoalCount,
}
